import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { IContextTipPayload } from "../types";

export const createContextTip = async (props: IContextTipPayload) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/context-tips`;
  const formData = new FormData();
  formData.append("title", props.title);
  if (props.subtitle) formData.append("subtitle", props.subtitle);
  if (props.icon) formData.append("icon", props.icon);

  return axios.post(url, formData, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const useCreateContextTip = () => useMutation(createContextTip);
